var exports = {
  "m": "Octicon__r0zs4V",
  "E": "Text__7BPxZA",
};

module.exports = exports;
